import React, { useState } from 'react';
import { hardReloadApp } from '../utils/hardReload';

export default function RefreshAppButton({ className = 'mps-btn mps-btn-secondary mps-btn-sm', label = 'Refresh app' }) {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await hardReloadApp();
    } catch {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      disabled={busy}
      title="Clear cached files and load the latest version of the app"
    >
      {busy ? 'Refreshing…' : label}
    </button>
  );
}
